import { getUrlParamsDecoded } from "System/utilities/strings.js";
import langstore from 'System/i18n/translator.js';

// generic error


// execute login
const ssoGemoLogin = async function (userData) {

  let url = this.config.paths.apiURL + "profilo/ssologin/gemo/login";

  let response = await this.dataLayer({
    url: url,
    cacheAge: 0,
    params: userData,
    rawResponse: true
  });

  return response;
}


// validate ID token
const ssoGemoUsers = async function (params) {

  let url = this.config.paths.apiURL + "profilo/ssologin/gemo/users";

  let response = await this.dataLayer({
    url: url,
    cacheAge: 0,
    params: {
      id: params.id,
      cliente: parseInt(params.cliente),
      userid: params.userid
    },
    rawResponse: true
  });

  return response;
}

// Reset page by showing a loading message
const resetSsoPage = function () {
  this.gemoSsoStatus = {
    title: langstore.t("ssoGemoLogin_wait", "Attendere..."),
    message: "",
    showLoginLink: false
  };

  return;
}

const ssoGemoActions = async function () {
  // Reset page
  this.resetSsoPage();

  let loadingKey = "ssoGemoActions";
  let { op, id, userid, cliente } = getUrlParamsDecoded();

  // Show an error message if wrong format
  if (!op || !id || !userid || !cliente) {
    this.routeChange("login");
    this.notificationAdd(langstore.t("sso_gemo_error_params", "Formato URL errato"), loadingKey);
    return;
  }

  // Add loader
  this.loadingAdd(loadingKey);

  // case: login
  if (op == "LOGIN") {
    try {
      // Get sso users
      const userListResp = await this.ssoGemoUsers({ op, id, userid, cliente });
      const {
        status: userListStatus,
        statusCode: userListStatusCode,
        data: userListData
      } = userListResp || {};
      const {
        users: userListUsers,
        c_nome: clientCode,
        ragione_sociale: clientName
      } = userListData || {};

      // If invalid user provided in the userId token, then return an error
      if (userListStatus == "ERROR" && userListStatusCode == "USER_NOT_FOUND") {
        this.gemoSsoStatus = {
          title: langstore.t("gemoSsoLogin_userNotFound_title", "Utente non trovato"),
          message: "",
          showLoginLink: true
        };
        this.loadingRemove(loadingKey);
        return;
      }
      else if (userListStatus == "ERROR" && userListStatusCode == "CLIENT_NOT_FOUND") {
        this.gemoSsoStatus = {
          title: langstore.t("gemoSsoLogin_clientNotFound_title", "Cliente non trovato"),
          message: "",
          showLoginLink: true
        };
        this.loadingRemove(loadingKey);
        return;
      }
      else if (userListStatus == "ERROR" && userListStatusCode == "USER_NOT_ENABLED") {
        this.gemoSsoStatus = {
          title: langstore.t("gemoSsoLogin_invalidUser_title", "Utente non abilitato"),
          message: langstore.t("gemoSsoLogin_invalidUser_title", {
            defaultValue: "Il cliente {{clientCode}} - {{- clientName}} non è abilitato al portale clienti.",
            clientCode,
            clientName
          }),
          showLoginLink: true
        };
        this.loadingRemove(loadingKey);
        return;
      }
      // Else if error page then show generic error
      else if (!userListResp || userListStatus !== "OK" || !userListData || !userListUsers || userListUsers.length == 0) {
        this.gemoSsoStatus = {
          title: langstore.t("gemoSsoLogin_invalidLogin_title", "Errore"),
          message: langstore.t("gemoSsoLogin_invalidLogin_message", "Si \xE8 verificato un errore. Impossibile effettuare il login."),
          showLoginLink: true
        };
        this.loadingRemove(loadingKey);
        return;
      }

      /**
       * Try login with first user in returned list
       * TODO: Will become selectable
       */
      const loginUserResp = await this.ssoGemoLogin(userListUsers[0]);
      const {
        status: loginUserStatus,
        data: loginUserData
      } = loginUserResp || {};
      const { auth: loginUserAuth } = loginUserData || {};

      if (!loginUserResp || loginUserStatus !== "OK" || !loginUserData || !loginUserAuth) { // last check was < !userListAuth !== true > but seems wrong
        this.gemoSsoStatus = {
          title: langstore.t("gemoSsoLogin_invalidLogin_title", "Errore"),
          message: langstore.t("gemoSsoLogin_invalidLogin_message", "Si \xE8 verificato un errore. Impossibile effettuare il login."),
          showLoginLink: true
        };
        this.loadingRemove(loadingKey);
        return;
      }

      this.userAuth(loginUserResp, loadingKey);
      this.routeChange(this.config.routes.index);
    }
    catch (e) {
      this.notificationAdd(langstore.t("sso_gemo_error", "Si \xE8 verificato un errore"), "ssoGemoActions");
      this.routeChange("login");
      this.loadingRemove(loadingKey);
      return;
    }
  }
}



export {
  resetSsoPage,
  ssoGemoActions,
  ssoGemoUsers,
  ssoGemoLogin
}